"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = exports.questions = void 0;

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var surveyscreeners = [_utils.screeners.WHO5RTWUS, _utils.screeners.RTW_US_ONBOARDING, _utils.screeners.ECOVALUS, _utils.screeners.RTW_US_FEEDBACK];
var questions = (0, _screeners.expandscreeners)([].concat(surveyscreeners));
exports.questions = questions;

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answers[screener], screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answers[screener][i]);
    });
  });
  return results;
};

exports.analysis = analysis;